<template>
  <div>
    <div class="serviceContent">
      <div style="overflow:hidden" class="serviceTitle">
        <div class="content">
          <div class="thumb">
            <i class="iconfont iconhome"></i>
            <span>主页</span>
            <i class="iconfont iconyou"></i>
            <span @click="goBack()">创客发布</span>
            <i class="iconfont iconyou"></i>
            <span>研发服务</span>
          </div>
          <div style="margin-top:10px">
            <img src="../../public/images/serviceInfo/makerTitle.jpg" />
          </div>
        </div>
      </div>
      <div class="content">
        <div class="makerContent">
          <div class="content1">
            <div class="info1" style="display: flex;">
              <div style="flex:0.8">
                <h1>{{makerInfo.serviceName}}</h1>
                <div style="width: 45px;height: 3px;background-color: #5fccff;margin-top:15px"></div>
                <div style="display: flex;margin-top:10px   ">
                  <img src="../../public/images/serviceInfo/makerImg.png" />
                  <div>
                    <p
                      style="font-size: 24px;font-weight:600;margin-top:10px"
                    >{{makerInfo.serviceCompany}}</p>
                    <p style="font-size: 18px;margin-top:10px">西安 | 135******190</p>
                  </div>
                </div>
              </div>
              <div style="flex:0.2">
                <div class="relation">
                  <p>联系电话</p>
                </div>
              </div>
            </div>
            <div class="info2">
              <h1>
                <span></span>技能介绍
              </h1>
              <P cal>工作经验：{{makerInfo.education}}</P>
              <P>技能名称：{{makerInfo.skillName}}</P>
              <P>学历：{{makerInfo.education}}</P>
              <P>技能熟练程度：{{makerInfo.proficiency}}</P>
              <h1>
                <span></span>技能描述
              </h1>
              <p>{{makerInfo.explain}}</p>
            </div>
          </div>
          <div class="content2">
            <div style="background:#fff;padding: 30px;">
              <P
                style="font-size: 24px;color: #333333;text-align:centerpadding-bottom: 20px;border-bottom: solid 1px #cccc;padding-bottom: 20px;"
              >
                <img src="../../public/images/serviceInfo/hot.png" style="margin-right: 8px;" />热门合作伙伴
              </P>
              <div style="padding:25px 70px 30px 0px">
                <div
                  class="hote"
                  v-for="(item,index) in hoteList"
                  :key="index"
                  style="margin-top: 15px;"
                >
                  <p>{{item.serviceName}}</p>
                  <span style="color:#5fccff">——</span>
                  <P style="color: #4b4b4b;font-size: 18px;">{{item.makerName}}</P>
                  <P style="margin: 5px 0px;">{{item.experience}}</P>
                  <div class="bottom"></div>
                </div>
              </div>
            </div>
            <div style="margin-top:10px">
              <img src="../../public/images/serviceInfo/makerFooter.jpg" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Nav :message="scroll"></Nav>
    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/nav";
import Footer from "../components/footer";
export default {
  data () {
    return {
      scroll: '1',
      hoteList: [
        {
          serviceName: "实验技术操作人员",
          makerName: "李*浩",
          experience: "工作经验：5年"
        },
        {
          serviceName: "JAVA技术研发",
          makerName: "李*玉",
          experience: "工作经验：3年"
        },
        {
          serviceName: "广告服务",
          makerName: "广*丽",
          experience: "工作经验：2年"
        },
      ],
      makerInfo: {}
    }
  },
  created () {
    this.makerInfo = JSON.parse(this.$route.query.data)
  },
  mounted () {
    window.scrollTo(0, 0);
  },
  methods: {
    goBack () {
      this.$router.push({
        path: '/market',
        query: { data: 2 }
      })
    }
  },
  components: {
    Nav,
    Footer,
  },
}
</script>

<style scoped>
.thumb {
  margin-top: 30px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 5px;
  color: #515151;
  font-size: 13px;
}
.thumb > span {
  padding: 0 10px;
}
.serviceContent {
  background: #f1f3f8;
  width: 100%;
  padding-bottom: 50px;
  padding-top: 106px;
}
.titleImg {
  background: url("/public/images/serviceInfo/makerTitle.jpg");
}
/* 中心内容 */
.makerContent {
  display: flex;
  margin-top: 8px;
}
.makerContent .content1 {
  background: #f1f3f8;
  width: 100%;
  margin-right: 10px;
}
.content1 .info1 {
  padding: 35px 60px 40px 45px;
  background: #ffffff;
  margin-bottom: 20px;
}
.content1 .info1 .relation {
  width: 193px;
  height: 65px;
  background-color: #5fccff;
  box-shadow: 0px 2px 1px 0px rgba(0, 8, 34, 0.25);
  margin-top: 40px;
  cursor: pointer;
}
.content1 .info1 .relation p {
  text-align: center;
  color: #ffffff;
  font-size: 26px;
  line-height: 65px;
}
.content1 .info1 h1 {
  font-family: "SimHei";
  font-size: 42px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 25px;
  letter-spacing: 0px;
  color: #4b4b4b;
}
.content1 .info2 {
  padding: 30px 50px;
  background: #ffffff;
}
.content1 .info2 span {
  width: 6px;
  height: 20px;
  background-color: #5fccff;
  display: inline-block;
  margin-right: 5px;
}
.content1 .info2 h1 {
  font-size: 30px;
  font-weight: bold;
}
.content1 .info2 p {
  font-size: 20px;
  color: #4b4b4b;
  margin: 20px 0px;
}
.makerContent .content2 {
  width: 450px;
  background: #f1f3f8;
  cursor: pointer;
}
.content2 .hote p:nth-child(1) {
  font-size: 28px;
  line-height: 25px;
  height: 29px;
  font-weight: 600;
  letter-spacing: 0px;
}
.content2 .hote p:last-child {
  color: #4b4b4b;
  font-size: 20px;
}
.content2 .hote .bottom {
  width: 300px;
  text-align: right;
  margin-top: 15px;
  border: dashed 1px #ccc;
  margin-left: 30px;
}
</style>